module.exports = __webpack_public_path__ + "img/hr-stack-filter-inserter-hand-open.59630a60.png";